import { loanTypeTone, shortLoanTypeLabel, type LoanTypeCategory } from "@/utils/loanType";

/**
 * Loan-type values are DB-driven (`loan_type.collection_category`), so this is
 * the KNOWN set, not a closed one — accept any string and render it verbatim.
 */
export type LoanType = LoanTypeCategory;

interface LoanTypeBadgeProps {
  loanType?: LoanType | string | null;
  className?: string;
}

const TONE_STYLES: Record<string, string> = {
  e2w: "bg-emerald-100 text-emerald-800 border border-emerald-200 shadow-sm",
  "3w": "bg-amber-100 text-amber-800 border border-amber-200 shadow-sm",
  l3: "bg-teal-100 text-teal-800 border border-teal-200 shadow-sm",
  l4: "bg-sky-100 text-sky-800 border border-sky-200 shadow-sm",
  l5: "bg-violet-100 text-violet-800 border border-violet-200 shadow-sm",
  battery: "bg-orange-100 text-orange-800 border border-orange-200 shadow-sm",
  unknown: "bg-gray-100 text-gray-800 border border-gray-200 shadow-sm",
};

const LoanTypeBadge = ({ loanType, className = "" }: LoanTypeBadgeProps) => {
  if (!loanType || String(loanType).trim() === "") {
    return null;
  }

  const rawValue = String(loanType).trim();
  const style = TONE_STYLES[loanTypeTone(rawValue)] ?? TONE_STYLES.unknown;
  const displayLabel = shortLoanTypeLabel(rawValue);

  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold tracking-wide ${style} ${className}`}
      title={`Product: ${displayLabel}`}
    >
      {displayLabel}
    </span>
  );
};

export default LoanTypeBadge;
